import { useEffect } from 'react';
import { debounce } from 'lodash';

function useIdleTimer(callback, timeout = 180 * 1000) {
  useEffect(() => {
    if (timeout > 0) {
      const trackedEvents = ['keypress', 'mousedown', 'touchstart'];
      let isCompleted = false;
      let timer = setTimeout(callback, timeout);
      const resetTimer = debounce(() => {
        //it is possible for resetTimer to be triggered after the return function is exectued
        //checking isCompleted ensures the timer isn't reset.
        if (!isCompleted) {
          clearTimeout(timer);
          timer = setTimeout(callback, timeout);
        }
      }, 200);

      trackedEvents.forEach(event =>
        document.addEventListener(event, resetTimer)
      );

      return () => {
        isCompleted = true;
        trackedEvents.forEach(event =>
          document.removeEventListener(event, resetTimer)
        );
        clearTimeout(timer);
      };
    }
  }, [callback, timeout]);
}

export default useIdleTimer;
